.loading {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 24rem;
}

.empty {
  color: var(--muted);
  font-size: var(--text-min-body);
  margin: 0.5rem 0;
}
